import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDrawer1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconDrawer1"><Path fillRule="evenodd" clipRule="evenodd" d="M4 10V2H20V10H4ZM9 5H15V7H9V5Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M4 12V20H6V22H8V20H16V22H18V20H20V12H4ZM15 15H9V17H15V15Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDrawer1;
